// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2e2z71wUx{height:100%;position:relative;overflow:hidden}html[data-supports-mobile] ._2e2z71wUx{height:100%}.zOTfHinKx{height:100%;position:absolute;overflow-x:hidden;width:100%}._11FUCobqx{height:100%;position:absolute;width:100%;overflow-y:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch}._11FUCobqx._1vJRDz1Hx{scrollbar-width:thin}._11FUCobqx._1vJRDz1Hx::-webkit-scrollbar{width:6px;background-color:transparent}._11FUCobqx._1vJRDz1Hx::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,0.3);border-radius:6px}._5W2dOKy0x{display:block;height:60px;position:relative;width:100%}._5W2dOKy0x._2Vsv517wx{height:30px}._2ABPKLzux{height:100%;overflow-x:hidden;position:absolute;width:100%}._2ABPKLzux ._11FUCobqx{transform:translateX(100%)}._3icJ1qlMx,._1RDEZaQKx{height:100%;overflow-x:hidden;position:absolute;width:100%}._3icJ1qlMx ._11FUCobqx,._1RDEZaQKx ._11FUCobqx{transform:translateX(0%)}._1qf0Fnhax ._11FUCobqx{transform:translateX(-100%);transition:transform 300ms cubic-bezier(0.165, 0.84, 0.44, 1)}._6GVsGfFsx{height:100%;overflow-x:hidden;position:absolute;width:100%}._6GVsGfFsx ._11FUCobqx{transform:translateX(-100%)}._362SivjXx,._3SDs4Ikvx{height:100%;overflow-x:hidden;position:absolute;width:100%}._362SivjXx ._11FUCobqx,._3SDs4Ikvx ._11FUCobqx{transform:translateX(0%);transition:transform 300ms cubic-bezier(0.165, 0.84, 0.44, 1)}._5BOrDzk1x ._11FUCobqx{transform:translateX(100%);transition:transform 300ms cubic-bezier(0.165, 0.84, 0.44, 1)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"transition-group": "_2e2z71wUx",
	"transitionGroup": "_2e2z71wUx",
	"nav-body-container": "zOTfHinKx",
	"navBodyContainer": "zOTfHinKx",
	"nav-items-container": "_11FUCobqx",
	"navItemsContainer": "_11FUCobqx",
	"expanded": "_1vJRDz1Hx",
	"app-info": "_5W2dOKy0x",
	"appInfo": "_5W2dOKy0x",
	"mobile": "_2Vsv517wx",
	"enter-left": "_2ABPKLzux",
	"enterLeft": "_2ABPKLzux",
	"leave-right": "_3icJ1qlMx",
	"leaveRight": "_3icJ1qlMx",
	"leave-left": "_1RDEZaQKx",
	"leaveLeft": "_1RDEZaQKx",
	"leave-active-left": "_1qf0Fnhax",
	"leaveActiveLeft": "_1qf0Fnhax",
	"enter-right": "_6GVsGfFsx",
	"enterRight": "_6GVsGfFsx",
	"enter-active-right": "_362SivjXx",
	"enterActiveRight": "_362SivjXx",
	"enter-active-left": "_3SDs4Ikvx",
	"enterActiveLeft": "_3SDs4Ikvx",
	"leave-active-right": "_5BOrDzk1x",
	"leaveActiveRight": "_5BOrDzk1x"
};
module.exports = exports;
